import './App.css';
import * as React from "react";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON, Circle, Pane, Layer, ControlledLayer} from 'react-leaflet';
import graphFromOsm from 'graph-from-osm';
import Async from 'react-async';
import L, { geoJSON, map, marker, Control } from "leaflet";
import { createControlComponent } from "@react-leaflet/core";
import "leaflet-routing-machine";
import * as rand from './random';
import { useEffect, useState } from 'react';
import * as Markers from './markers';

var arrHospitales = Markers.arrHospitales
var arrColegios = Markers.arrColegios
var arrHospitalesAux = []
var arrColegiosAux = []
var arrPoliciaAux = []
var arrBomberosAux = []
var arr

var tool = "nodes"
var selected
var selectedAux
var selectedNode

function randomColor() {
  /*const red = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  const green = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  const blue = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  return `#${red}${green}${blue}`; */
  const colores = ['white','#BDFFFF','#BDDEFF','#BDBDFF','#DEBDFF','#B2FFCE','#B2FFF5','#B2E3FF','#FFBDDE','#FFBDFF','#F4B2FF']
  //const colores = ['white','#FF93EB','#1C80B5','#1C34B5','#511CB5','#9D1CB5','#B51C80','#B51C33']
  return colores[Math.floor(Math.random()*colores.length)];
}

var color = randomColor()
var color2 = color
while (color2 === color) {
  color2 = randomColor()
}

const crearNode = document.querySelector('button[name=nodes]')
const crearEdge = document.querySelector('button[name=edges-one]')
const crearEdgeDoble = document.querySelector('button[name=edges-doble]')
const closebtn = document.querySelector('button[name=closebtn]')
const sidebar = document.querySelector('.sidebar_left')
const sidebar2 = document.querySelector('.sidebar_left2')
const mostrarInfo = document.getElementById("info")
var mostrarInfoBool = false
var mostrarInfoBool2 = false

closebtn.addEventListener("click", () => {
  closebtn.setAttribute("class","closebtn on")
  //console.log(sidebar.className)
  if(sidebar.className === "sidebar_left") {
    sidebar.setAttribute("class","sidebar_left_closed")
    document.getElementById("mañanas").setAttribute("class","btnclosed")
    document.getElementById("tardes").setAttribute("class","btnclosed")
    document.getElementById("robo").setAttribute("class","btnclosed")
    document.getElementById("incendio").setAttribute("class","btnclosed")
    document.getElementById("emergencia").setAttribute("class","btnclosed")
    document.getElementById("suministrar").setAttribute("class","btnclosed")
  }
  else {
    closebtn.setAttribute("class","closebtn")
    sidebar.setAttribute("class","sidebar_left")
    document.getElementById("mañanas").setAttribute("class","mañanas")
    document.getElementById("tardes").setAttribute("class","tardes")
    document.getElementById("robo").setAttribute("class","robo")
    document.getElementById("incendio").setAttribute("class","incendio")
    document.getElementById("emergencia").setAttribute("class","emergencia")
    document.getElementById("suministrar").setAttribute("class","suministrar")
  }
})
/*
mostrarInfo.addEventListener("click", () => {
  if(mostrarInfo.className === "info on") {
    mostrarInfo.setAttribute("class","info")
    mostrarInfoBool = false
    
    
    

  } else {
    mostrarInfo.setAttribute("class","info on")
    mostrarInfoBool = true
    //info()
  }
})

mostrarInfo2.addEventListener("click", () => {
  if(mostrarInfo2.className === "info on") {
    mostrarInfo2.setAttribute("class","info")
    mostrarInfoBool2 = false
    //clearInfo2()
  } else {
    mostrarInfo2.setAttribute("class","info on")
    mostrarInfoBool2 = true
    //info2()
  }
})



crearNode.addEventListener("click", () => {
  document.querySelector(".edges-one").setAttribute("class", "edges-one")
  document.querySelector(".edges-doble").setAttribute("class", "edges-doble")
  crearNode.setAttribute("class","nodes on")
  console.log("Tool: nodes")
  tool = "nodes"
  //changeCursor()
})

crearEdge.addEventListener("click", () => {
  //document.querySelectorAll(".tool").forEach((function(x){x.setAttribute("class", "tool");}))
  document.querySelector(".nodes").setAttribute("class", "nodes")
  document.querySelector(".edges-doble").setAttribute("class", "edges-doble")
  crearEdge.setAttribute("class","edges-one on")
  console.log("Tool: edges-one")
  tool = "edges-one"
  //changeCursor()
})

crearEdgeDoble.addEventListener("click", (e) => {
  //document.querySelectorAll(".tool").forEach((function(x){x.setAttribute("class", "tool");}))
  document.querySelector(".nodes").setAttribute("class", "nodes")
  document.querySelector(".edges-one").setAttribute("class", "edges-one")
  crearEdgeDoble.setAttribute("class","edges-doble on")
  console.log("Tool: edges-doble")
  tool = "edges-doble"
  //changeCursor()
})*/

const generateGraph = async (settings) => {
  const osmData = await graphFromOsm.getOsmData(settings);   // Import OSM raw data
  const graph = graphFromOsm.osmDataToGraph(osmData)         // Here is your graph
  //console.log(Object.entries(graph))
  return graph
}

const mySettings = {                                         // Define my settings
  bbox: [rand.Ciudad.longitud - 0.01, rand.Ciudad.latitud - 0.01, rand.Ciudad.longitud + 0.01, rand.Ciudad.latitud + 0.01],
  highways: "ALL",
  timeout: 600000000, maxContentLength: 1500000000
}

const loadGraph = async () => {
  const res = await generateGraph(mySettings)
  return res
}


var LeafIcon = L.Icon.extend({
  options: {
    iconSize:     [44, 46], // size of the icon
    shadowSize:   [44, 46], // size of the shadow
    iconAnchor:   [22, 48], // point of the icon which will correspond to marker's location
    shadowAnchor: [22, 48],  // the same for the shadow
    popupAnchor:  [-2, -50] // point from which the popup should open relative to the iconAnchor
  }
});

var HospitalIcon = new LeafIcon({iconUrl: 'hospital-ico.png', shadowUrl: 'sombra-ico.png'})
var EscuelaIcon = new LeafIcon({iconUrl: 'escuela-ico.png', shadowUrl: 'sombra-ico.png'})
var PoliciaIcon = new LeafIcon({iconUrl: 'policia-ico.png', shadowUrl: 'sombra-ico.png'})
var BomberosIcon = new LeafIcon({iconUrl: 'bomberos-ico.png', shadowUrl: 'sombra-ico.png'})
var PanIcon = new LeafIcon({iconUrl: 'pan-ico.png', shadowUrl: 'sombra-ico.png'})
var MercadoIcon = new LeafIcon({iconUrl: 'mercado-ico.png', shadowUrl: 'sombra-ico.png'})


function App() {
    const [useNum, setNum] = useState({
      uno: 0,
      dos: 0
    })
    const [useArr, setArr] = useState({
      policia: [],
      bomberos: [],
      pan: [],
      mercado: [],
    })

    var alerta = 'Espere a que cargue el mapa.'
  const rutaOptima = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || 
      Markers.arrPolicia.length === 0 || Markers.arrPanadería.length === 0 || !oneClick.boolean){
      alert(alerta)
      return
    }
    var inicio = document.getElementById("desde").value //obtener seleccionado
    var destino = document.getElementById("hasta").value //obtener seleccionado
    inicio = inicio.slice(7)
    var iniciolat = rand.arrFamilias[inicio-1].latitud
    var iniciolon = rand.arrFamilias[inicio-1].longitud
    if(destino.startsWith('hospital')) {
      destino = destino.slice(8)
      var finallat = arrHospitales[destino].center.lat
      var finallon = arrHospitales[destino].center.lon
    }
    if(destino.startsWith('colegio')) {
      destino = destino.slice(7)
       var finallat = arrColegios[destino].center.lat
       var finallon = arrColegios[destino].center.lon
      }
  const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(iniciolat, iniciolon),
        L.latLng(finallat, finallon),
      ],
      lineOptions: {
        styles: [{color: 'var(--danger)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };
  
  const RoutingMachine = createControlComponent(createRoutineMachineLayer);
  //
    var randNum = useNum.uno
    var randNum2 = useNum.dos
    arrHospitalesAux = [arrHospitales[randNum].center.lat, arrHospitales[randNum].center.lon]
    arrColegiosAux = [arrColegios[randNum2].center.lat, arrColegios[randNum2].center.lon]
    var FamiliaMarkers = Markers.Familia
    var n
      setState(({Map: Map}) => {
    return {
      Map: 
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <FamiliaMarkers/>
    <Marker key={`hospital-${2}`} position={arrHospitalesAux} icon={HospitalIcon}>
    <Popup>
      <span>{arrHospitales[randNum].tags.name}. <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`escuela-${2}`} position={arrColegiosAux} icon={EscuelaIcon}>
    <Popup>
      <span>{arrColegios[randNum2].tags.name} <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`policia-${1}`} position={useArr.policia} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={useArr.bomberos} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={useArr.mercado} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[useNum.cuatro].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={useArr.pan} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[useNum.tres].tags.name} <br/> </span>
      </Popup>
      </Marker>
    <RoutingMachine/>
  </MapContainer>
    }
  })
  }

  const rutinaMañana = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || 
      Markers.arrPolicia.length === 0 || Markers.arrPanadería.length === 0 || !oneClick.boolean){
      alert(alerta)
      return
    }
    var inicio = document.getElementById("familia").value //obtener seleccionado
    var destino = document.getElementById("hasta").value //obtener seleccionado
    inicio = inicio.slice(7)
    var iniciolat = rand.arrFamilias[inicio-1].latitud
    var iniciolon = rand.arrFamilias[inicio-1].longitud
    var finallat = arrColegios[useNum.dos].center.lat
    var finallon = arrColegios[useNum.dos].center.lon
  const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(iniciolat, iniciolon),
        L.latLng(finallat, finallon)
      ],
      lineOptions: {
        styles: [{color: 'var(--danger)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };
  const createRoutineMachineLayer2 = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(finallat, finallon),
        L.latLng(iniciolat, iniciolon),
      ],
      lineOptions: {
        styles: [{color: 'var(--blue)', opacity: 'var(--opacidad)', weight: 9}]
     }

    });
    return instance;
  };
  const RoutingMachine = createControlComponent(createRoutineMachineLayer);
  const RoutingMachine2 = createControlComponent(createRoutineMachineLayer2);

  //
    var randNum = useNum.uno
    var randNum2 = useNum.dos
    arrHospitalesAux = [arrHospitales[randNum].center.lat, arrHospitales[randNum].center.lon]
    arrColegiosAux = [arrColegios[randNum2].center.lat, arrColegios[randNum2].center.lon]
    var FamiliaMarkers = Markers.Familia
      setState(({Map: Map}) => {
    return {
      Map: 
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <FamiliaMarkers/>
    <Marker key={`hospital-${2}`} position={arrHospitalesAux} icon={HospitalIcon}>
    <Popup>
      <span>{arrHospitales[randNum].tags.name}. <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`escuela-${2}`} position={arrColegiosAux} icon={EscuelaIcon}>
    <Popup>
      <span>{arrColegios[randNum2].tags.name} <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`policia-${1}`} position={useArr.policia} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={useArr.bomberos} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={useArr.mercado} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[useNum.cuatro].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={useArr.pan} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[useNum.tres].tags.name} <br/> </span>
      </Popup>
      </Marker>
    <RoutingMachine/>
    <RoutingMachine2/>
  </MapContainer>
    }
  })
  }
  
  const rutinaTarde = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || 
      Markers.arrPolicia.length === 0 || Markers.arrPanadería.length === 0 || !oneClick.boolean){
      alert(alerta)
      return
    }
    var inicio = document.getElementById("familia").value //obtener seleccionado
    var destino = document.getElementById("hasta").value //obtener seleccionado
    inicio = inicio.slice(7)
    var iniciolat = rand.arrFamilias[inicio-1].latitud
    var iniciolon = rand.arrFamilias[inicio-1].longitud
    var finallat = arrColegios[useNum.dos].center.lat
    var finallon = arrColegios[useNum.dos].center.lon
    var panlat = Markers.arrPanadería[useNum.tres].center.lat
    var panlon = Markers.arrPanadería[useNum.tres].center.lon

  const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(iniciolat, iniciolon),
        L.latLng(finallat, finallon)
      ],
      lineOptions: {
        styles: [{color: 'var(--danger)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };

  const createRoutineMachineLayer2 = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(finallat, finallon),
        L.latLng(panlat, panlon),
      ],
      lineOptions: {
        styles: [{color: 'var(--blue)',opacity: 'var(--opacidad)', weight: 9}]
     }

    });
    return instance;
  };
  
  const createRoutineMachineLayer3 = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(panlat, panlon),
        L.latLng(iniciolat, iniciolon),
      ],
      lineOptions: {
        styles: [{color: 'var(--green)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };

  const RoutingMachine = createControlComponent(createRoutineMachineLayer);
  const RoutingMachine2 = createControlComponent(createRoutineMachineLayer2);
  const RoutingMachine3 = createControlComponent(createRoutineMachineLayer3);

  //
    var randNum = useNum.uno
    var randNum2 = useNum.dos
    arrHospitalesAux = [arrHospitales[randNum].center.lat, arrHospitales[randNum].center.lon]
    arrColegiosAux = [arrColegios[randNum2].center.lat, arrColegios[randNum2].center.lon]
    var FamiliaMarkers = Markers.Familia
      setState(({Map: Map}) => {
    return {
      Map: 
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <FamiliaMarkers/>
    <Marker key={`hospital-${2}`} position={arrHospitalesAux} icon={HospitalIcon}>
    <Popup>
      <span>{arrHospitales[randNum].tags.name}. <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`escuela-${2}`} position={arrColegiosAux} icon={EscuelaIcon}>
    <Popup>
      <span>{arrColegios[randNum2].tags.name} <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`policia-${1}`} position={useArr.policia} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={useArr.bomberos} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={useArr.mercado} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[useNum.cuatro].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={useArr.pan} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[useNum.tres].tags.name} <br/> </span>
      </Popup>
      </Marker>
    <RoutingMachine/>
    <RoutingMachine2/>
    <RoutingMachine3/>
  </MapContainer>
    }
  })
  }
  
  
  const robo = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || 
      Markers.arrPolicia.length === 0 || Markers.arrPanadería.length === 0 || !oneClick.boolean){
      alert(alerta)
      return
    }
    var inicio = document.getElementById("familia").
    value //obtener seleccionado
    var destino = document.getElementById("hasta").value //obtener seleccionado
    inicio = inicio.slice(7)
    var iniciolat = rand.arrFamilias[inicio-1].latitud
    var iniciolon = rand.arrFamilias[inicio-1].longitud
    var finallat = Markers.arrPolicia[0].center.lat
    var finallon = Markers.arrPolicia[0].center.lon
  const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(finallat, finallon),
        L.latLng(iniciolat, iniciolon),
      ],
      lineOptions: {
        styles: [{color: 'var(--danger)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };

  const RoutingMachine = createControlComponent(createRoutineMachineLayer);

  //
    var randNum = useNum.uno
    var randNum2 = useNum.dos
    var FamiliaMarkers = Markers.Familia
      setState(({Map: Map}) => {
    return {
      Map: 
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <FamiliaMarkers/>
    <Marker key={`hospital-${2}`} position={arrHospitalesAux} icon={HospitalIcon}>
    <Popup>
      <span>{arrHospitales[randNum].tags.name}. <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`escuela-${2}`} position={arrColegiosAux} icon={EscuelaIcon}>
    <Popup>
      <span>{arrColegios[randNum2].tags.name} <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`policia-${1}`} position={useArr.policia} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={useArr.bomberos} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={useArr.mercado} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[useNum.cuatro].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={useArr.pan} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[useNum.tres].tags.name} <br/> </span>
      </Popup>
      </Marker>
    <RoutingMachine/>
  </MapContainer>
    }
  })
  }

  const emergencia = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || 
      Markers.arrPolicia.length === 0 || Markers.arrPanadería.length === 0 || !oneClick.boolean){
      alert(alerta)
      return
    }
    var inicio = document.getElementById("familia").value //obtener seleccionado
    var destino = document.getElementById("hasta").value //obtener seleccionado
    inicio = inicio.slice(7)
    var iniciolat = rand.arrFamilias[inicio-1].latitud
    var iniciolon = rand.arrFamilias[inicio-1].longitud
    var finallat = arrHospitales[useNum.uno].center.lat
    var finallon = arrHospitales[useNum.uno].center.lon
  const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(iniciolat, iniciolon),
        L.latLng(finallat, finallon)
      ],
      lineOptions: {
        styles: [{color: 'var(--danger)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };

  const RoutingMachine = createControlComponent(createRoutineMachineLayer);

  //
    var randNum = useNum.uno
    var randNum2 = useNum.dos
    arrHospitalesAux = [arrHospitales[randNum].center.lat, arrHospitales[randNum].center.lon]
    arrColegiosAux = [arrColegios[randNum2].center.lat, arrColegios[randNum2].center.lon]
    var FamiliaMarkers = Markers.Familia
      setState(({Map: Map}) => {
    return {
      Map: 
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <FamiliaMarkers/>
    <Marker key={`hospital-${2}`} position={arrHospitalesAux} icon={HospitalIcon}>
    <Popup>
      <span>{arrHospitales[randNum].tags.name}. <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`escuela-${2}`} position={arrColegiosAux} icon={EscuelaIcon}>
    <Popup>
      <span>{arrColegios[randNum2].tags.name} <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`policia-${1}`} position={useArr.policia} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={useArr.bomberos} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={useArr.mercado} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[useNum.cuatro].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={useArr.pan} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[useNum.tres].tags.name} <br/> </span>
      </Popup>
      </Marker>
    <RoutingMachine/>
  </MapContainer>
    }
  })
  }

  const incendio = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || Markers.arrPolicia.length === 0 || 
      Markers.arrPanadería.length === 0 || !oneClick.boolean){
      alert(alerta)
      return
    }
    var inicio = document.getElementById("familia").value //obtener seleccionado
    var destino = document.getElementById("hasta").value //obtener seleccionado
    inicio = inicio.slice(7)
    var iniciolat = rand.arrFamilias[inicio-1].latitud
    var iniciolon = rand.arrFamilias[inicio-1].longitud
    var finallat = Markers.arrBomberos[0].center.lat
    var finallon = Markers.arrBomberos[0].center.lon
  const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(finallat, finallon),
        L.latLng(iniciolat, iniciolon),
      ],
      lineOptions: {
        styles: [{color: 'var(--danger)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };

  const RoutingMachine = createControlComponent(createRoutineMachineLayer);

  //
    var randNum = useNum.uno
    var randNum2 = useNum.dos
    var FamiliaMarkers = Markers.Familia
      setState(({Map: Map}) => {
    return {
      Map: 
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <FamiliaMarkers/>
    <Marker key={`hospital-${2}`} position={arrHospitalesAux} icon={HospitalIcon}>
    <Popup>
      <span>{arrHospitales[randNum].tags.name}. <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`escuela-${2}`} position={arrColegiosAux} icon={EscuelaIcon}>
    <Popup>
      <span>{arrColegios[randNum2].tags.name} <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`policia-${1}`} position={useArr.policia} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={useArr.bomberos} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={useArr.mercado} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[useNum.cuatro].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={useArr.pan} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[useNum.tres].tags.name} <br/> </span>
      </Popup>
      </Marker>
    <RoutingMachine/>
  </MapContainer>
    }
  })
  }

  const suministrar = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || 
      Markers.arrPolicia.length === 0 || Markers.arrPanadería.length === 0 || !oneClick.boolean){
      alert(alerta)
      return
    }
    var inicio = document.getElementById("familia").value //obtener seleccionado
    var destino = document.getElementById("hasta").value //obtener seleccionado
    inicio = inicio.slice(7)
    var iniciolat = rand.arrFamilias[inicio-1].latitud
    var iniciolon = rand.arrFamilias[inicio-1].longitud
    var finallat = Markers.arrMercados[useNum.cuatro].center.lat
    var finallon = Markers.arrMercados[useNum.cuatro].center.lon
  const createRoutineMachineLayer = (props) => {
    const instance = L.Routing.control({
      createMarker: function() { return null },
      waypoints: [
        L.latLng(iniciolat, iniciolon),
        L.latLng(finallat, finallon),
      ],
      lineOptions: {
        styles: [{color: 'var(--danger)', opacity: 'var(--opacidad)', weight: 9}]
     }
    });
    return instance;
  };

  const RoutingMachine = createControlComponent(createRoutineMachineLayer);

  //
    var randNum = useNum.uno
    var randNum2 = useNum.dos
    var FamiliaMarkers = Markers.Familia
      setState(({Map: Map}) => {
    return {
      Map: 
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <FamiliaMarkers/>
    <Marker key={`hospital-${2}`} position={arrHospitalesAux} icon={HospitalIcon}>
    <Popup>
      <span>{arrHospitales[randNum].tags.name}. <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`escuela-${2}`} position={arrColegiosAux} icon={EscuelaIcon}>
    <Popup>
      <span>{arrColegios[randNum2].tags.name} <br/> Easily customizable.</span>
    </Popup>
    </Marker>
    <Marker key={`policia-${1}`} position={useArr.policia} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={useArr.bomberos} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={useArr.mercado} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[useNum.cuatro].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={useArr.pan} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[useNum.tres].tags.name} <br/> </span>
      </Popup>
      </Marker>
    <RoutingMachine/>
  </MapContainer>
    }
  })
  }

  var [oneClick, setClicked] = useState({boolean:false})

  const [state, setState] = useState({
    Map:
    <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
    <TileLayer
      attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
        <Async promiseFn={loadGraph}>
      {({ data, error, isPending }) => {
        var grafo
        if (isPending) return <GeoJSON attribution="&copy; credits due..." data={grafo} />
        if (error) return <GeoJSON attribution="&copy; credits due..." data={grafo} />
        if (data) {
          console.log('Graph cargado.')
          return (
            <GeoJSON attribution="&copy; credits due..." data={grafo} />
          )
        }
          
        return null
      }}
    </Async>
  </MapContainer>
  })

  
  const reloadMap = () => {
    if(arrColegios.length === 0 || arrHospitales.length === 0 || Markers.arrBomberos.length === 0 || Markers.arrMercados.length === 0 || Markers.arrPolicia.length === 0 || Markers.arrPanadería.length === 0){
      alert(alerta)
      return
    }
    if(oneClick.boolean) return
    var randNum = 0 + Math.random() * (0 + arrHospitales.length -1)
        randNum = Math.round(randNum)
    var randNum2 = 0 + Math.random() * (0 + arrColegios.length -1)
        randNum2 = Math.round(randNum2)
    var randNum3 = 0 + Math.random() * (0 + Markers.arrPanadería.length - 1)
        randNum3 = Math.round(randNum3)
    var randNum4 = 0 + Math.random() * (0 + Markers.arrMercados.length - 1)
        randNum4 = Math.round(randNum4)
    setNum({uno: randNum, dos: randNum2, tres: randNum3, cuatro: randNum4})

    arrHospitalesAux = [arrHospitales[randNum].center.lat, arrHospitales[randNum].center.lon]
    arrColegiosAux = [arrColegios[randNum2].center.lat, arrColegios[randNum2].center.lon]
    var arrPoliciaAux = [Markers.arrPolicia[0].center.lat, Markers.arrPolicia[0].center.lon]
    var arrBomberosAux = [Markers.arrBomberos[0].center.lat, Markers.arrBomberos[0].center.lon]
    var arrPanAux = [Markers.arrPanadería[randNum3].center.lat, Markers.arrPanadería[randNum3].center.lon]
    var arrMercadoAux = [Markers.arrMercados[randNum4].center.lat, Markers.arrMercados[randNum4].center.lon]
    setArr({
      policia: [Markers.arrPolicia[0].center.lat, Markers.arrPolicia[0].center.lon],
      bomberos: [Markers.arrBomberos[0].center.lat, Markers.arrBomberos[0].center.lon],
      pan: [Markers.arrPanadería[randNum3].center.lat, Markers.arrPanadería[randNum3].center.lon],
      mercado: [Markers.arrMercados[randNum4].center.lat, Markers.arrMercados[randNum4].center.lon],
    })
    var nombreHospital = arrHospitales[randNum].tags.name
    var nombreColegio = arrColegios[randNum2].tags.name
    var FamiliaMarkers = Markers.Familia
    var desde = ''
    for (let i = 0; i < rand.arrFamilias.length; i++) {
      desde += `<option value="familia${i+1}">Familia ${i+1}</option>\n`
    }
    document.getElementById("desde").innerHTML = desde
    document.getElementById("familia").innerHTML = desde
    document.getElementById("hasta").innerHTML = `<option value="hospital${randNum}">${nombreHospital}</option>\n
    <option value="colegio${randNum2}">${nombreColegio}</option>\n`
    
    setClicked({boolean:true})
    setState(({Map: Map}) => {
      return {
        Map: 
      <MapContainer  center={[rand.Ciudad.latitud, rand.Ciudad.longitud]} zoom={15} scrollWheelZoom={true}>
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <FamiliaMarkers/>
      <Marker key={`hospital-${1}`} position={arrHospitalesAux} icon={HospitalIcon}>
      <Popup>
        <span>{arrHospitales[randNum].tags.name}. <br/> </span>
      </Popup>
    </Marker>
      <Marker key={`escuela-${1}`} position={arrColegiosAux} icon={EscuelaIcon}>
      <Popup>
        <span>{arrColegios[randNum2].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`policia-${1}`} position={arrPoliciaAux} icon={PoliciaIcon}>
      <Popup>
        <span>{Markers.arrPolicia[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`bomberos-${1}`} position={arrBomberosAux} icon={BomberosIcon}>
      <Popup>
        <span>{Markers.arrBomberos[0].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`mercado-${1}`} position={arrMercadoAux} icon={MercadoIcon}>
      <Popup>
        <span>{Markers.arrMercados[randNum4].tags.name} <br/> </span>
      </Popup>
      </Marker>
      <Marker key={`pan-${1}`} position={arrPanAux} icon={PanIcon}>
      <Popup>
        <span>{'Panadería ' + Markers.arrPanadería[randNum3].tags.name} <br/> </span>
      </Popup>
      </Marker>
    </MapContainer>
      }
    })
  }


  return (
    <div>
      <button onClick={reloadMap} className="generate" title="Generar aleatorio">
        <img className="ticon" src="https://www.iconninja.com/files/604/543/615/refresh-icon.svg" alt=""/>
      </button>
      <button onClick={rutaOptima} id="ruta" className="ruta" title="Buscar ruta óptima">
        <img className="ticon" src="https://cdn-icons-png.flaticon.com/512/13/13311.png" alt=""/>
      </button>
      <button onClick={rutinaMañana} id="mañanas" className="mañanas" title="Rutina mañanas">
        Rutina mañanas
      </button>
      <button onClick={rutinaTarde} id="tardes" className="tardes" title="Rutina tardes">
        Rutina tardes
      </button>
      <button onClick={incendio} id="incendio" className="incendio" title="Incendio">
        Incendio
      </button>
      <button onClick={robo}id="robo" className="robo" title="Robo">
        Robo
      </button>
      <button onClick={emergencia} id="emergencia" className="emergencia" title="Emergencia">
        Emergencia
      </button>
      <button onClick={suministrar} id="suministrar" className="suministrar" title="Suministrar">
        Suministrar
      </button>
     {state.Map}
    </div>
  );
}

export {arrHospitalesAux, arrColegiosAux}
export default App;
